import PropTypes from 'prop-types';

import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { Button, Typography } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

const MessageSellerButton = (props) => {
  const { t } = useTransl();
  const { onClick } = props;
  return (
    <Button
      onClick={onClick}
      sx={{ display: 'flex', gap: '0.5rem', color: 'inherit' }}
    >
      <ChatBubbleOutlineIcon fontSize="small" />
      <Typography>{t('community.messageSeller')}</Typography>
    </Button>
  );
};

MessageSellerButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default MessageSellerButton;
